(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craavr-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e,i){
      if(e.isIntersecting){setTimeout(function(){e.target.classList.add('v');},i*60);io.unobserve(e.target);}
    });
  },{threshold:0.07});
  document.querySelectorAll('.cr-r').forEach(function(el){io.observe(el);});
  document.querySelectorAll('.cr-card').forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width-0.5)*8;
      var y=((e.clientY-r.top)/r.height-0.5)*8;
      card.style.transform='perspective(1000px) rotateY('+x+'deg) rotateX('+(-y)+'deg) scale(1.02)';
      card.style.transition='transform 0.1s ease';
    });
    card.addEventListener('mouseleave',function(){
      card.style.transition='transform 0.6s ease';
      card.style.transform='';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craavr-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!document.getElementById('cr-fonts')){
    var l=document.createElement('link');
    l.id='cr-fonts';l.rel='stylesheet';
    l.href='https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Inter:wght@300;400;500&display=swap';
    document.head.appendChild(l);
  }
  var media=document.getElementById('crMedia');
  var dotsEl=document.getElementById('crDots');
  if(media&&dotsEl){
    var slides=Array.from(media.querySelectorAll('.cr-slide'));
    var ci=0;
    if(slides.length>1){
      slides.forEach(function(_,i){
        var d=document.createElement('div');
        d.className='cr-dot'+(i===0?' a':'');
        d.onclick=function(){go(i);};
        dotsEl.appendChild(d);
      });
      var dots=dotsEl.querySelectorAll('.cr-dot');
      function go(n){
        slides[ci].classList.remove('cr-on');dots[ci].classList.remove('a');
        ci=(n+slides.length)%slides.length;
        slides[ci].classList.add('cr-on');dots[ci].classList.add('a');
        var v=slides[ci].querySelector('video');
        if(v){v.currentTime=0;v.play();}
      }
      setInterval(function(){go(ci+1);},5000);
    }
  }
  setTimeout(function(){
    var e=document.getElementById('crEye');if(e)e.classList.add('v');
    var w=document.getElementById('crWm');if(w)w.classList.add('v');
  },100);
  setTimeout(function(){var f=document.getElementById('crFoot');if(f)f.classList.add('v');},650);
  var btn=document.getElementById('crBtn');
  if(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      var x=(e.clientX-r.left-r.width/2)*0.35;
      var y=(e.clientY-r.top-r.height/2)*0.35;
      btn.style.transform='translate('+x+'px,'+y+'px)';
    });
    btn.addEventListener('mouseleave',function(){btn.style.transform='';});
  }
  window.addEventListener('scroll',function(){
    var nav=document.querySelector('header,.header-wrapper');
    if(nav){nav.style.background=window.scrollY>80?'rgba(8,8,8,0.96)':'';nav.style.backdropFilter=window.scrollY>80?'blur(20px)':'';nav.style.transition='background 0.4s';}
  },{passive:true});
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e,i){
      if(e.isIntersecting){setTimeout(function(){e.target.classList.add('v');},i*70);io.unobserve(e.target);}
    });
  },{threshold:0.07});
  document.querySelectorAll('.cr-r').forEach(function(el){io.observe(el);});
  document.querySelectorAll('.cr-card').forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width-0.5)*8;
      var y=((e.clientY-r.top)/r.height-0.5)*8;
      card.style.transform='perspective(1000px) rotateY('+x+'deg) rotateX('+(-y)+'deg) scale(1.02)';
      card.style.transition='transform 0.1s ease';
    });
    card.addEventListener('mouseleave',function(){
      card.style.transition='transform 0.6s ease';
      card.style.transform='';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Nav scroll
  var nav = document.getElementById('crNav');
  window.addEventListener('scroll', function(){
    if(nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }, {passive: true});

  // Mobile burger
  var burger = document.getElementById('crBurger');
  var menu = document.getElementById('crMobileMenu');
  if(burger && menu){
    burger.addEventListener('click', function(){
      burger.classList.toggle('open');
      menu.classList.toggle('open');
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
